module.exports = __webpack_public_path__ + "img/zjbb5.ec421f76.jpg";